/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Button, Glyphicon, Table } from "react-bootstrap";

const FileDisplay = props => {
  const { file } = props;
  return (
    <Table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Type</th>
          <th>Size</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{file.name}</td>
          <td>{file.extension}</td>
          <td>{file.sizeReadable}</td>
          <td>
            <Button
              bsSize="xsmall"
              bsStyle="danger"
              title="Remove"
              onClick={props.onRemove}
            >
              <Glyphicon glyph="remove" />
            </Button>
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
FileDisplay.propTypes = {
  file: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default FileDisplay;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/upload/FileDisplay.js